/**
 * One frame of a picture (spec 035): frame `index` of its cut, or the whole
 * picture when it has none, scaled to fit a `size` px square.
 */
import React from 'react';
import type { SheetCut, SpriteSize } from '../../../../Shared/src/@types';
import { sheetFrameRect } from '../../../../Shared/src/utils/spriteSheet';

export interface SheetFrameProps {
  src?: string;
  natural?: SpriteSize;
  cut?: SheetCut;
  index: number;
  size: number;
  testId?: string;
}

const SheetFrame: React.FC<SheetFrameProps> = ({ src, natural, cut, index, size, testId }) => {
  if (!src || !natural) return <div style={{ width: size, height: size }} data-testid={testId} data-frame={index} />;
  const rect = cut ? sheetFrameRect(cut, index, natural) : { x: 0, y: 0, w: natural.width, h: natural.height };
  const k = size / Math.max(1, rect.w, rect.h);
  return (
    <div
      data-testid={testId}
      data-frame={index}
      style={{
        width: rect.w * k,
        height: rect.h * k,
        backgroundImage: `url(${src})`,
        backgroundSize: `${natural.width * k}px ${natural.height * k}px`,
        backgroundPosition: `${-rect.x * k}px ${-rect.y * k}px`,
        backgroundRepeat: 'no-repeat',
        imageRendering: cut?.pixelArt ? 'pixelated' : undefined,
      }}
    />
  );
};

export default SheetFrame;
